export default __webpack_public_path__ + "assets/models/c4b85b0a84b6000a55dad21ba067a4fa.glb";